const $ = jQuery;
(function ( $ ) {
	$.fn.referenceShortcode = function() {
		var isOnScreen=  function(element, deb) {
			var elementOffsetTop = element.offset().top;
			var elementHeight = element.parent().height();
			var elementWidth = element.width();


			var screenScrollTop = $(window).scrollTop();
			var screenHeight = $(window).height();
			var screenWidth = $(window).width();
			var rect={};
			rect.y1 = Math.max(screenScrollTop, elementOffsetTop);
			rect.y2 = Math.min(elementOffsetTop+elementHeight, screenScrollTop+screenHeight);
			if (deb) 
				if (elementOffsetTop>screenHeight + screenScrollTop) {
					if (deb) alert('eltop not yet visible');
					return false;
				}
				if (rect.y2 < rect.y1) {
					if (deb) alert('humm');
					return false;
				}
				var visiblePourcentage =  (rect.y2-rect.y1)/(elementHeight);
				if (deb) alert(visiblePourcentage);
				return (visiblePourcentage > .25);
			}

			var num = 0;
			var footerNote;
			if (!$('body > .footer-references').length){
				$('body').append('<div class="footer-references"></div>');
				footerNote = $('body > .footer-references').css(
				{
					position: 'fixed',
					bottom: 0,
					transition: 'all .3s',
					left: 0,
					right: 0,
					background: 'white',
					boxShadow: '0 0 40px 26px rgba(255,255,255,1)',
					color: 'black',
					zIndex: 1000,
				});


			}
			footerNote = $('body > .footer-references');
			let lastPosition = null;
			$(this).each(function(){
				num++;
				let $this = this;
				var parentContainer = $(this).parent().css('position', 'relative');
				var content = $(this).find('.reference-content');
				$(this).find('sup').text(num).css('cursor', 'pointer');
				if (content.find('.reference-number').length===0) content.prepend('<span class="reference-number">'+num+' </span>');
				var mode = $(this).attr('data-position');
				if (mode === 'side-left' || mode=='side-right'){
					var parentbbox = parentContainer[0].getBoundingClientRect();
					var refbbox = this.getBoundingClientRect();
					var space = parentbbox.x - 20;
					if (mode==='side-right'){
						space = $(window).width() - parentbbox.x - parentbbox.width-20;
					}
					var dir = mode==='side-right'?'left':'right';

					var offset = refbbox.y - parentbbox.y;
					content.css({
						position: 'absolute',
						top: offset - 10,
						display: 'block',
						padding: '10px',
						fontSize: '14px',
						width: space+'px',

					}).css(dir, '100%');
					if (lastPosition){
						let rect = content[0].getBoundingClientRect();
						if (rect.y < lastPosition.y+lastPosition.height){
							let offsetFixed = offset+ lastPosition.y-10+lastPosition.height-rect.y;
							content.css('top', offsetFixed);
						}
						
					}
					lastPosition = content[0].getBoundingClientRect();


					content.addClass(mode);
				}


				if (mode === 'bottom' && isOnScreen($(this).find('sup'))){
					if (!footerNote.find('[ref="'+num+'"]').length){
						footerNote.append('<div ref="'+num+'" class="col-md-6 mx-auto py-2"> '+content.html()+'</div>');
						footerNote.find('[ref="'+num+'"]').click(function(){
							$this.click();
						});
					}

				}
				else {
					footerNote.find('[ref="'+num+'"]').remove();

				}
				if (footerNote.children().length){
					footerNote.fadeIn(100);
				}
				else{
					footerNote.fadeOut(100);

				}
				window.footerNote = footerNote;

			});
		};
	}( $ ));


let timer = null;
const setup = ()=>{
	timer = setInterval(()=>{
		if ($('[data-shortcode-tag="ref"]').length){
			$('[data-shortcode-tag="ref"]').referenceShortcode();
			
		}
	}, 1000);
}

export default setup;